import { CircularProgress } from "@mui/material";
import { useVerificationsQuery } from "Api/Queries/Verifications/useVerificationsQuery";
import { FinalStepContent } from "Components/Onboarding/NaturalPerson/Steps/FinalStep/FinalStepContent";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { Resources, useResource } from "Translations/Resources";

export const FinalStep = () => {
  const { data, isLoading } = useVerificationsQuery();
  const { t } = useResource();

  if (isLoading) {
    return <CircularProgress />;
  }

  if (!data) {
    return (
      <ErrorText>
        {t(Resources.Onboarding.Steps.FinalStep.LoadingError)}
      </ErrorText>
    );
  }

  return <FinalStepContent userVerificationData={data} />;
};
